<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('common_487')}}</div>
    <div slot="body">
      <cloud-account-init-setting ref="setting" :customerId="params.data[0].id" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import CloudAccountInitSetting from '../components/CloudAccountInitSetting'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'UpdateCloudAccountSettingDialog',
  components: {
    CloudAccountInitSetting,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    doUpdate (data) {
      return this.params.onManager('performAction', {
        id: this.params.data[0].id,
        managerArgs: {
          action: 'billing-profile',
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const data = await this.$refs.setting.getValues()
        await this.doUpdate(data)
        this.loading = false
        this.cancelDialog()
        this.$message.success(this.$t('common_396'))
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
